module.exports = __webpack_public_path__ + "img/logo.6e10d7c2.svg";